import { render } from "./IMessageAuthUsersPage.vue?vue&type=template&id=6bc7b2de"
import script from "./IMessageAuthUsersPage.vue?vue&type=script&lang=js"
export * from "./IMessageAuthUsersPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__